export default "__VITE_ASSET__Bl7wiDjP__"